<template>
    <div class="main">
        <div id="Nav" class="left">
            <div class="back"><button @click="back()" class="button icon fastic-circle-left" :aria-label="localizer.get('App.Common.PageBack')"></button></div>
            <div class="content">
                <h1 class="maintitle s60">{{ localizer.get("Account.PasswordReset.Title") }}</h1>
                <div class="desc">{{ localizer.get("Account.PasswordReset.Desc") }}</div>
            </div>
            <app-footer></app-footer>
        </div>
        <main id="Main" class="right">
            <div class="logo" data-color="cyan50">
                <a :href="routes.Home"><img src="/images/logo.svg" width="125" height="35" :alt="localizer.get('App.Common.Beghelli')" /></a>
            </div>
            <div @keydown.enter.prevent.stop="submitForm()" class="content">
                <div class="intro">
                    <h2 class="maintitle s36">{{ localizer.get("Account.PasswordReset.NewPassword") }}</h2>
                </div>
                <div v-if="options" ref="form" class="form">
                    <fieldset>
                        <div class="item">
                            <label for="Email">{{ localizer.get("App.Form.Email") }}</label>
                            <input type="email" id="Email" :placeholder="localizer.get('App.Form.EmailPlaceholder')" v-model.lazy="formData.email" :class="[{ 'input-validation-error': formHelper.isControlValidationError('Email', validationErrors) }, 'input w300']" />
                        </div>
                        <div class="item">
                            <label for="Password">{{ localizer.get("Account.Common.Password") }}</label>
                            <div class="custominput" data-type="password">
                                <input type="password" aria-label="Password" id="Password" v-model.lazy="formData.password" :class="[{ 'input-validation-error': formHelper.isControlValidationError('Password', validationErrors) }, 'input w300']" />
                                <button :class="[{ 'fastic-eye-show': isHidden, 'fastic-eye-hide': !isHidden }, 'showhide']" aria-label="Mostra password" @click="formHelper.showPassword('Password'), showPasswordIcon()"></button>
                            </div>
                        </div>
                        <div v-if="options.isPasswordCheck" class="item">
                            <label for="PasswordCheck">{{ localizer.get("Account.Common.PasswordCheck") }}</label>
                            <div class="custominput" data-type="password">
                                <input type="password" aria-label="Verifica password" id="PasswordCheck" v-model.lazy="formData.passwordCheck" :class="[{ 'input-validation-error': formHelper.isControlValidationError('PasswordCheck', validationErrors) }, 'input w300']" />
                                <button :class="[{ 'fastic-eye-show': isHiddenCheck, 'fastic-eye-hide': !isHiddenCheck }, 'showhide']" aria-label="Mostra password" @click="formHelper.showPassword('PasswordCheck'), showPasswordCheckIcon()"></button>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                            <ul>
                                <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                            </ul>
                        </div>
                        <div class="item">
                            <div class="cta">
                                <button :class="[{ 'loading': isLoading }, 'button']" @click="submitForm()"><template v-if="!isLoading">{{ localizer.get("Account.Common.Button_Next") }}</template></button>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{ code: string }>();

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const options = ref<any>(null);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const isHidden = ref(true);
const isHiddenCheck = ref(true);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_User_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    formData.value.code = props.code;
});

function back() {
    window.history.back();
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;

    try {
        let result = (await Axios.post(routes.Account_User_PasswordReset, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        isSuccess.value = true;
        window.location.href = result.redirectUrl;
    } catch (error: any) {
        formData.value.password = null;
        formData.value.passwordCheck = null;
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

function showPasswordCheckIcon() {
    isHiddenCheck.value = !isHiddenCheck.value;
}
</script>